import { alertStart } from "../../routes"
import { RegistrarLogErro } from "../../services/clientefiel"
import { buscarInformacoesPedido, getJSONNotaFiscal } from "../../services/integracao"
import useAppStore from "../../stores/AppStore"

const qz = require("qz-tray")

function chr(n) {
    return String.fromCharCode(n)
}
var code = "12345"

function tamanhoFont(texto) {
    return "\x0A" + "\x1B" + texto + "\x0D" + "\x1BSe\x0D"
}

function doubleFont(texto) {
    return "\x1B" + "\x4D" + "\x30" + "\x1D" + "\x21" + "\x11" + texto
}

function standardFont(texto) {
    return "\x1B" + "\x4D" + "\x30" + "\x1D" + "\x21" + "\x00" + texto
}

function smallFont(texto) {
    return "\x1D" + "\x21" + "\x00" + "\x1B" + "\x4D" + "\x30" + "\x1B" + "\x4D" + "\x31" + texto
}

function encondingPortugues() {
    return "\x1B" + "\x74" + "\x10"
}

function cortarComanda() {
    return "\x0A\x0A\x0A\x0A\x0A\x0A\x0A\x1B\x69"
}

export function textoConfigurado(configuracoes) {
    let { printer, texto } = configuracoes

    console.log("printer.tamanhoFonteSelect", printer.tamanhoFonteSelect)
    texto =
        encondingPortugues() +
        `${
            printer.tamanhoFonteSelect === "pequena"
                ? smallFont(texto)
                : printer.tamanhoFonteSelect === "grande"
                ? doubleFont(texto)
                : standardFont(texto)
        }` +
        cortarComanda()

    // texto = texto.replaceAll("<br>", "\n")

    const removerBarraN = 2
    for (let index = 0; index < removerBarraN; index++) {
        texto = texto.replace("\n", "")
    }

    return texto
}

export function imprimirCode(configuracoes) {
    let {
        pedido = {},
        texto = "",
        qtd = 1,
        qrcode = {},
        QZObrigatorio = false,
        numeroDaImpressora = 0,
        impressora = "",
        logo,
        printer,
        // qz,
    } = configuracoes

    const parametros = JSON.parse(localStorage.getItem("custom-params") ?? "{}")
    const avaliacaoGoogle = parametros.PUBLIC_QRCODE_COMANDA
        ? {
              texto: parametros.PUBLIC_QRCODE_COMANDA,
              descricao: "Link para avaliar o estabelecimento",
          }
        : null

    var config = qz.configs.create(impressora, configImage(qtd)) // Toggle Cp1252 in Java

    const imprimir = textoConfigurado(configuracoes)

    var qrCodePrint = ""

    if (logo) {
        // imprimir logo estabelecimento
        qrCodePrint = logo
    }

    var qrCodePrintAvaliacao = ""

    if (qrcode.texto) {
        var opts = {
            errorCorrectionLevel: "H",
            type: "image/jpeg",
            scale: 10,
        }
        var QRCode = require("qrcode")
        QRCode.toDataURL(qrcode.texto, opts, function (err, url) {
            qrCodePrint = url
        })
    }

    if (avaliacaoGoogle) {
        var opts = {
            errorCorrectionLevel: "H",
            type: "image/jpeg",
            scale: 10,
        }
        var QRCode = require("qrcode")
        QRCode.toDataURL(avaliacaoGoogle.texto, opts, function (err, url) {
            qrCodePrintAvaliacao = url
        })
    }

    const boldOn = configuracoes.printer.negrito ? { data: "\x1B" + "\x45" + "\x0D" } : null
    const boldOff = configuracoes.printer.negrito ? { data: "\x1B" + "\x45" + "\x0A" } : null

    let arrayConfig = [
        { data: "\x1B" + "\x61" + "\x31" },
        { data: "\x1B" + "\x61" + "\x31" + (qrcode?.descricao ?? "") + "\n" },
        dataImage(qrCodePrint),
        { data: "\x1B" + "\x61" + "\x31" + (avaliacaoGoogle?.descricao ?? "") + "\n" },
        dataImage(qrCodePrintAvaliacao),
        { data: "\x1B" + "\x61" + "\x30" + imprimir },
    ]

    const arrayConfigEnviar = configuracoes.printer.negrito
        ? [boldOn, ...arrayConfig, boldOff]
        : arrayConfig

    console.log("mandei imprimir", config, { imprimir, printer })

    qz.print(config, arrayConfigEnviar).catch(error => {
        RegistrarLogErro(error, "qz.print", configuracoes)
        console.error(error)

        if (error.message.includes('"bufferedImage" is null'))
            alertStart(
                `Erro ao imprimir logo no pedido ${pedido.id}, desative o parâmetro e tente novamente`,
                "error"
            )
        else alertStart(error.message, "error")
    })
}

function imprimirComQRCode(configuracoes) {
    const {
        qtd = 1,
        qrcode = {},
        impressora = "",
        // qz,
        printer,
    } = configuracoes

    const QRCode = require("qrcode")

    var config = qz.configs.create(impressora, { encoding: "ISO-8859-1" })

    const fonteA = "\x1B\x4D\x01"
    const fonteB = "\x1B\x4D\x02" // Mais alta e fina (utilizamos como média)

    const fonteDobrada = "\x1D\x21\x11"

    const espacoMenorEntreLinhas = "\x1B\x33\x14"

    let tamanhoFonte = fonteA

    switch (printer.tamanhoFonteSelect) {
        case "pequena":
            tamanhoFonte = fonteB + espacoMenorEntreLinhas
            break
        case "grande":
            tamanhoFonte = fonteB + fonteDobrada
            break
    }

    const QRCodeOpts = { scale: 5 } // TODO: Checar se usa tamanhoFonteSelect para alterar

    QRCode.toDataURL(qrcode.link, QRCodeOpts, (error, qrCodeURL) => {
        if (error) {
            console.error(error)
            return
        }

        for (var i = 0; i < qtd; i++) {
            const printData = [
                "\x1B" + "\x40",
                tamanhoFonte,
                ...qrcode.textosAntes,

                {
                    type: "raw",
                    format: "image",
                    data: qrCodeURL,
                    options: { language: "ESCPOS", dotDensity: "double" },
                },

                ...qrcode.textosDepois,
            ]

            qz.print(config, printData).catch(e => console.error(e))
        }
    })
}

export function imprimirNotaCancelada(configuracoes) {
    let {
        pedido = {},
        texto = "",
        qtd = 1,
        qrcode = {},
        QZObrigatorio = false,
        numeroDaImpressora = 0,
        impressora = "",
        logo,
        printer,
        // qz,
    } = configuracoes

    // qrcode = {descricao: 'PIX', texto: 'PIX'}

    var config = qz.configs.create(impressora, configImage()) // Toggle Cp1252 in Java

    for (var i = 0; i < qtd; i++) {
        qz.print(config, [
            {
                data: "\x1B" + "\x61" + "\x31",
            },
            {
                data: "\x1B" + "\x61" + "\x30" + texto,
            },
        ])
    }
}

function formatarDinheiroParaImpressao(valor) {
    return "R$ " + Math.abs(valor).toFixed(2).replace(".", ",")
}

function removeAcento(text) {
    try {
        return text
            .replace(new RegExp("[ÁÀÂÃ]", "gi"), "a")
            .replace(new RegExp("[ÉÈÊ]", "gi"), "e")
            .replace(new RegExp("[ÍÌÎ]", "gi"), "i")
            .replace(new RegExp("[ÓÒÔÕ]", "gi"), "o")
            .replace(new RegExp("[ÚÙÛ]", "gi"), "u")
            .replace(new RegExp("[Ç]", "gi"), "c")
    } catch (error) {
        RegistrarLogErro(error, "removeAcento(qzConfig)", text)
    }
}

export async function imprimirNotaFiscal(idPedido) {
    try {
        if (!idPedido) return

        const configuracoes = useAppStore.getState().configuracoes

        const colunasPorLinhaImpressao = configuracoes.user.parametros.colunasPorLinhaImpressao

        const notaFiscal = await getJSONNotaFiscal(idPedido)

        const autorizacao = localStorage.getItem("chaveSistema")
        const pedido = await buscarInformacoesPedido(autorizacao, idPedido)

        if (notaFiscal.retornoErro) {
            // alertStart(notaFiscal.mensagem, "error")
            RegistrarLogErro(notaFiscal, "imprimirNotaFiscal", { idPedido })
            return
        }

        const NFe = notaFiscal.NFe ?? notaFiscal

        const razaoSocial = NFe?.infNFe?.emit?.xFant
        const CNPJ = NFe?.infNFe?.emit?.CNPJ?.replace(
            /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/,
            "$1.$2.$3/$4-$5"
        )
        const inscricaoEstadual = NFe?.infNFe?.emit?.IE

        const telefoneContatoEmpresa = (fone => {
            if (!fone) return undefined

            switch (fone.length) {
                case 8:
                    return fone.replace(/^(\d{4})(\d{4}).*/, "$1-$2")
                case 9:
                    return fone.replace(/^(\d{5})(\d{4}).*/, "$1-$2")
                case 10:
                    return fone.replace(/^(\d{2})(\d{4})(\d{4}).*/, "($1)$2-$3")
                case 11:
                    return fone.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1)$2-$3")
                default:
                    return fone
            }
        })(NFe.infNFe?.emit.enderEmit.fone)

        const ruaEmpresa = NFe.infNFe?.emit.enderEmit.xLgr
        const numeroEmpresa = NFe.infNFe?.emit.enderEmit.nro
        const bairroEmpresa = NFe.infNFe?.emit.enderEmit.xBairro
        const municipioEmpresa = NFe.infNFe?.emit.enderEmit.xMun
        const estadoEmpresa = NFe.infNFe?.emit.enderEmit.UF
        const stringEnderecoEmpresa = `${ruaEmpresa}, ${numeroEmpresa}\x0A${bairroEmpresa}, ${municipioEmpresa}, ${estadoEmpresa}`

        const chaveAcesso = NFe.infNFeSupl?.urlChave
        const qrCodeNF = NFe.infNFeSupl?.qrCode
        const chaveNF = notaFiscal.protNFe?.infProt.chNFe.match(/.{1,4}/g).join(" ")
        const dataEmissaoNF = NFe.infNFe?.ide.dhEmi

        const diaEmissaoNF = dataEmissaoNF?.split("T")[0].split("-")
        const horarioEmissaoNF = dataEmissaoNF?.split("T")[1].split("-")[0].split(":")

        const cpfCliente = NFe.infNFe?.dest?.CPF?.replace(
            /^(\d{3})(\d{3})(\d{3})(\d{2}).*/,
            "$1.$2.$3-$4"
        )

        const cnpjCliente = NFe.infNFe?.dest?.CNPJ?.replace(
            /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/,
            "$1.$2.$3/$4-$5"
        )

        const stringData = `${diaEmissaoNF?.[2]}/${diaEmissaoNF?.[1]}/${diaEmissaoNF?.[0]} ${horarioEmissaoNF?.[0]}:${horarioEmissaoNF?.[1]}:${horarioEmissaoNF?.[2]}`

        const lineBreak = "\x0A"
        const centerAlign = "\x1B" + "\x61" + "\x31"
        const leftAlign = "\x1B" + "\x61" + "\x30"
        const rightAlign = "\x1B" + "\x61" + "\x32"

        const boldOn = "\x1B" + "\x45" + "\x0D"
        const boldOff = "\x1B" + "\x45" + "\x0A"

        let textosItens = pedido.items.reduce((acc, item) => {
            const opcoes = item.subItems
                ? item.subItems.reduce((accOpt, opcao) => {
                      const textoOpcao = ("  " + opcao.quantity + "x " + opcao.name).slice(
                          0,
                          colunasPorLinhaImpressao - 11
                      )

                      const numeroDeEspaços = colunasPorLinhaImpressao - 8 - textoOpcao.length

                      return [
                          ...accOpt,
                          opcao.totalPrice
                              ? textoOpcao +
                                " ".repeat(numeroDeEspaços) +
                                formatarDinheiroParaImpressao(opcao.price)
                              : textoOpcao,
                          lineBreak,
                          leftAlign,
                      ]
                  }, [])
                : []

            const textoItem = (item.quantity + "x " + item.name).slice(
                0,
                colunasPorLinhaImpressao - 11
            )

            const numeroDeEspaços = colunasPorLinhaImpressao - 8 - textoItem.length

            return [
                ...acc,
                item.price
                    ? textoItem +
                      " ".repeat(numeroDeEspaços) +
                      formatarDinheiroParaImpressao(item.price)
                    : textoItem,
                lineBreak,
                ...opcoes,
            ]
        }, [])

        if (useAppStore.getState().configuracoes.user?.parametros.imprimirSemAcento)
            textosItens = textosItens.map(linha => removeAcento(linha))

        const textoSubTotal = "Subtotal"

        const subTotalComanda =
            textoSubTotal +
            " ".repeat(colunasPorLinhaImpressao - 8 - textoSubTotal.length) +
            formatarDinheiroParaImpressao(pedido.subTotal)

        const textoFormaPagamento = (
            pedido.discountPayment > 0 ? "Desc. Forma Pagamento" : "Adc. Forma Pagamento"
        ).slice(0, colunasPorLinhaImpressao - 8)

        const adcFormaPagamento =
            textoFormaPagamento +
            " ".repeat(colunasPorLinhaImpressao - 8 - textoFormaPagamento.length) +
            formatarDinheiroParaImpressao(Math.abs(pedido.discountPayment))
        const textoDesconto = "Desconto"

        const descontoComanda =
            textoDesconto +
            " ".repeat(colunasPorLinhaImpressao - 8 - textoDesconto.length) +
            formatarDinheiroParaImpressao(pedido.discountOrder)

        const textoTaxaEntrega = "Taxa de Entrega"

        const taxaEntregaComanda =
            textoTaxaEntrega +
            " ".repeat(colunasPorLinhaImpressao - 8 - textoTaxaEntrega.length) +
            formatarDinheiroParaImpressao(pedido.deliveryFee)

        const textoTotal = "TOTAL"

        const totalComanda =
            textoTotal +
            " ".repeat(colunasPorLinhaImpressao - 8 - textoTotal.length) +
            formatarDinheiroParaImpressao(pedido.totalPrice)

        imprimirNotaGeral({
            qrcode: {
                link: qrCodeNF,
                textosAntes: [
                    centerAlign,
                    lineBreak,
                    "Documento Auxiliar da Nota Fiscal",
                    lineBreak,
                    "Eletronica para Consumidor Final",
                    lineBreak,
                    lineBreak,
                    leftAlign,
                    razaoSocial,
                    lineBreak,
                    "CNPJ: " + CNPJ + " " + "IE: " + inscricaoEstadual,
                    lineBreak,
                    telefoneContatoEmpresa ? "Tel.: " + telefoneContatoEmpresa : "",
                    lineBreak,
                    telefoneContatoEmpresa ? lineBreak : "",
                    stringEnderecoEmpresa,
                    lineBreak,
                    lineBreak,
                    leftAlign,
                    "Item" + " ".repeat(colunasPorLinhaImpressao - 9) + "Valor",
                    lineBreak,
                    "=".repeat(colunasPorLinhaImpressao),
                    lineBreak,
                    ...textosItens,
                    lineBreak,
                    "=".repeat(colunasPorLinhaImpressao),
                    lineBreak,
                    pedido.discountPayment ? adcFormaPagamento : "",
                    pedido.discountPayment ? lineBreak : "",
                    pedido.discountOrder ? descontoComanda : "",
                    pedido.discountOrder ? lineBreak : "",
                    pedido.deliveryFee ? taxaEntregaComanda : "",
                    pedido.deliveryFee ? lineBreak : "",
                    "=".repeat(colunasPorLinhaImpressao),
                    lineBreak,
                    totalComanda,
                    lineBreak,
                    centerAlign,
                    lineBreak,
                    lineBreak,
                    centerAlign,
                    "Emissao: " + stringData,
                    lineBreak,
                    "Via Consumidor",
                    lineBreak,
                    cpfCliente
                        ? "CPF Consumidor: " + cpfCliente
                        : cnpjCliente
                        ? "CNPJ Consumidor: " + cnpjCliente
                        : "CONSUMIDOR NAO IDENTIFICADO",
                    lineBreak,
                    lineBreak,
                    "Consulte pela Chave de Acesso em:",
                    lineBreak,
                    chaveAcesso,
                    lineBreak,
                    "Chave:",
                    lineBreak,
                    chaveNF,
                    lineBreak,
                ],
                textosDepois: [lineBreak, lineBreak, lineBreak],
            },
            printer: configuracoes.printer,
            impressora: configuracoes.printer.impressoras[0],
            qz,
        })
    } catch (error) {
        console.error(error)
        // alertStart(error, "error")
        RegistrarLogErro(error, "imprimirNotaFiscal", { idPedido })
    }
}

export function imprimirNotaGeral(configuracoes) {
    try {
        const {
            qtd = 1,
            qrcode = {},
            impressora = "",
            // qz,
            printer,
        } = configuracoes

        console.warn("imprimirNotaGeral => ", configuracoes)

        if (qrcode?.link) {
            imprimirComQRCode(configuracoes)
        } else {
            imprimirNotaCancelada(configuracoes)
        }
    } catch (error) {
        RegistrarLogErro(error, "imprimirNotaGeral", configuracoes)
    }
}

export function imprimirHTML(configuracoes) {
    let {
        pedido = {},
        texto = "",
        qtd = 1,
        qrcode = {},
        QZObrigatorio = false,
        numeroDaImpressora = 0,
        impressora = "",
        logo,
        printer,
        // qz,
    } = configuracoes

    let config = qz.configs.create(impressora, configHtml(qtd))
    const tamanhoFonte =
        !printer.tamanhoFonteImpressao || printer.tamanhoFonteImpressao < 6
            ? 14
            : printer.tamanhoFonteImpressao

    let data = [
        {
            type: "html",
            format: "plain", // or 'plain' if the data is raw HTML
            data: `<div style="color:#0c0d0e;width:100%;margin:0;padding:0;font-weight:700;line-height:normal;font-size:${tamanhoFonte}px;font-family:Arial,sans-serif;">${texto.replace(
                /\n/g,
                "<br>"
            )}</div>`,
        },
    ]
    console.log("print", config, data)
    qz.print(config, data)
}

export function configHtml(qtd = 1) {
    return {
        copies: qtd,
        scaleContent: true,
        margins: { top: 0, right: 0, bottom: 0, left: 0 },
        orientation: "portrait",
    }
}

export function configCode() {
    return {
        copies: 1,
        scaleContent: true,
        margins: { top: 0, right: 0, bottom: 0, left: 0 },
        orientation: "portrait",
    }
}

export function configImage(qtd = 1) {
    return {
        bounds: null,
        colorType: "grayscale",
        copies: qtd,
        density: 0,
        duplex: false,
        fallbackDensity: null,
        interpolation: "bicubic",
        jobName: null,
        legacy: false,
        margins: 0,
        orientation: null,
        paperThickness: null,
        printerTray: null,
        rasterize: false,
        rotation: 0,
        scaleContent: true,
        size: null,
        units: "in",
        altPrinting: false,
        encoding: "Cp1252",
        spool: {},
    }
}

export function dataImage(imgPrint) {
    if (!imgPrint) {
        return {
            data: "",
        }
    }
    return {
        type: "raw",
        format: "image",
        data: imgPrint,
        options: {
            language: "ESCPOS",
            x: "0",
            y: "0",
            dotDensity: "double",
            xmlTag: "v7:Image",
            pageWidth: "480",
            pageHeight: "",
        },
    }
}
